module.exports = __webpack_public_path__ + "outlabel_cases.jpg?4b21a51a6088bddd066502ddddf07661";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cases/outlabel_cases.jpg
// module id = 90
// module chunks = 0